export const formattedTime = (time) => {
  const hh = time / 3600 | 0;
  const mm = (time / 60 | 0) % 60;
  const ss = time % 60;
  return `${ `0${ hh }`.slice(-2) }:${ `0${ mm }`.slice(-2) }:${ `0${ ss }`.slice(-2) }`;
};

export const shortFormattedTime = (time) => {
  const hh = time / 3600 | 0;
  const mm = (time / 60 | 0) % 60;
  const ss = time % 60;
  return (hh) ?
    `${ `0${ hh }`.slice(-2) }:${ `0${ mm }`.slice(-2) }:${ `0${ ss }`.slice(-2) }` :
    `${ `0${ mm }`.slice(-2) }:${ `0${ ss }`.slice(-2) }`;
};
